export type ContactPoint = {
  "@type": "ContactPoint";
  contactType: string;
  telephone: string;
  email: string;
};

export type OpeningHoursSpecification = {
  "@type": "OpeningHoursSpecification";
  dayOfWeek: string | string[];
  opens: string;
  closes: string;
};

export type GeoCoordinates = {
  "@type": "GeoCoordinates";
  latitude: number;
  longitude: number;
};

export type LocationFeatureSpecification = {
  "@type": "LocationFeatureSpecification";
  name: string;
  value: boolean;
};

export type SiteBusiness = {
  name: string;
  legalName: string;
  logo: string;
  image: string;
  telephone: string;
  address: {
    "@type": "PostalAddress";
    streetAddress: string;
    addressLocality: string;
    postalCode: string;
    addressCountry: string;
  };
  geo: GeoCoordinates;
  hasMap: string;
  contactPoints: ContactPoint[];
  openingHoursSpecification: OpeningHoursSpecification[];
  award: string[];
  sameAs: string[];
  currenciesAccepted: string;
  paymentAccepted: string;
  servesCuisine: string[];
  menu: string;
  acceptsReservations: string;
  checkinTime: string;
  checkoutTime: string;
  amenityFeature: LocationFeatureSpecification[];
};

export const siteBusiness: SiteBusiness = {
  name: "Militärkantine St.Gallen",
  legalName: "Militärkantine St.Gallen AG",
  logo: "/assets/logos/mika.png",
  image: "/assets/logos/hausfavorit.jpg",
  telephone: "+41 71 279 10 00",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Kreuzbleicheweg 2",
    addressLocality: "St.Gallen",
    postalCode: "9000",
    addressCountry: "CH",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 47.42185,
    longitude: 9.37291,
  },
  hasMap: "https://maps.app.goo.gl/GuAk6oDHPQDetRfJ7",
  contactPoints: [
    {
      "@type": "ContactPoint",
      contactType: "Reservations",
      telephone: "+41 71 279 10 00",
      email: "essen@militaerkantine.ch",
    },
    {
      "@type": "ContactPoint",
      contactType: "Room Reservations",
      telephone: "+41 71 279 10 00",
      email: "schlafen@militaerkantine.ch",
    },
  ],
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday"],
      opens: "07:00",
      closes: "24:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Friday",
      opens: "07:00",
      closes: "01:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Saturday",
      opens: "08:00",
      closes: "01:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Sunday", "PublicHolidays"],
      opens: "08:00",
      closes: "24:00",
    },
  ],
  award: [
    "ibex fairstay platinum",
    "Responsible Hotels of Switzerland",
    "Cause We Care (myclimate)",
    "Swisstainable Leading",
  ],
  sameAs: [
    "https://maps.app.goo.gl/GuAk6oDHPQDetRfJ7",
    "https://responsiblehotels.ch/hotels/militarkantine",
    "https://www.myswitzerland.com/de-ch/erlebnisse/essen-trinken/restaurant/restaurant-militaerkantine/",
    "https://www.myswitzerland.com/de-ch/unterkuenfte/militaerkantine/",
    "https://www.ginto.guide/entries/d28c04ba-f82a-4755-a1e4-33631cd567ba",
  ],
  currenciesAccepted: "CHF",
  paymentAccepted: "Cash, Credit Card",
  servesCuisine: ["Swiss", "European"],
  menu: "https://www.militaerkantine.ch/de/essen/",
  acceptsReservations:
    "https://guest.foratable.com/restaurants/019cb84a3d66738f9220d0d9120909fa",
  checkinTime: "15:00",
  checkoutTime: "11:00",
  amenityFeature: [
    { "@type": "LocationFeatureSpecification", name: "Parking", value: true },
    {
      "@type": "LocationFeatureSpecification",
      name: "Electric Vehicle Charging Station",
      value: true,
    },
    { "@type": "LocationFeatureSpecification", name: "Free WiFi", value: true },
    { "@type": "LocationFeatureSpecification", name: "Elevator", value: true },
    {
      "@type": "LocationFeatureSpecification",
      name: "Wheelchair Accessible",
      value: true,
    },
    {
      "@type": "LocationFeatureSpecification",
      name: "Wheelchair Accessible Entrance",
      value: true,
    },
    {
      "@type": "LocationFeatureSpecification",
      name: "Wheelchair Accessible Restroom",
      value: true,
    },
    {
      "@type": "LocationFeatureSpecification",
      name: "Wheelchair Accessible Seating",
      value: true,
    },
    {
      "@type": "LocationFeatureSpecification",
      name: "Baby Changing Facility",
      value: true,
    },
  ],
};
